import DashboardActions from '../../../../actions/DashboardActions';
import moment from 'moment-timezone';
import config from '../../../../config';
import store from '../../../../stores/redux';
import { metrics } from 'utils/ReportComponent/config';

export const actions = {
    getData() {
        const hoursArray = _getHoursArray();
        if (!hoursArray.length) return;

        const user = store.getState().user || {};
        const timezone = user?.timezone || 'UTC';
        const currency = user?.publisher?.account?.balance?.currency || 'USD';

        const segments = {
            Rejected: { values: [0], exclusive: false },
            DayHour: { values: hoursArray, exclusive: false }
        };

        const columns = Object.keys(metrics).filter((m) => metrics[m].visible === true);

        const params = {
            publishers: [],
            group_by: 'Day',
            from_day: moment().startOf('day').subtract(1, 'days').format(config.reportHourFormat),
            to_day: moment().endOf('day').format(config.reportHourFormat),
            use_registered_date: '0',
            registered_from_day: moment().startOf('day').subtract(1, 'days').format(config.reportHourFormat),
            registered_to_day: moment().endOf('day').format(config.reportHourFormat),
            bind_actions: 'time',
            timezone,
            currency,
            segments: JSON.stringify(segments),
            columns,
            totals: '0',
            isAdvertiser: 1
        };

        DashboardActions.getTodayData(params);
    }
};

const _getHoursArray = () => {
    const curHour = moment().hour();
    const hours = [];
    for (let i = 0; i < curHour; i++) hours.push(i);
    return hours;
};
